export const keys = {
  UZUM_CONFIG: "UZUM_CONFIG",
  UZUM_HOUSES: "UZUM_HOUSES"
}